import React, { useState, useRef } from "react";
import styled from "styled-components";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDays } from "@fortawesome/free-solid-svg-icons";
import ClearIcon from "./ClearIcon";

const DatePickerWrapper = styled.div`
  max-width: 380px;
  width: 100%;
  margin: 10px auto;
`;

const InputContainer = styled.div`
  background-color: rgba(255, 255, 255, 0.9);
  height: 55px;
  border-radius: 55px;
  display: flex;
  align-items: center;
  padding: 0 1rem;
  position: relative;
  border: ${(props) =>
    props.focused ? "2px solid #0098DB" : "2px solid rgba(255, 255, 255, 0.3)"};
  box-shadow: ${(props) =>
    props.focused
      ? "0 0 5px rgba(0, 152, 219, 0.5)"
      : "0 2px 8px rgba(0, 0, 0, 0.2)"};
  transition: border 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
  box-sizing: border-box;
`;

const InputIcon = styled(FontAwesomeIcon)`
  text-align: center;
  color: ${(props) => (props.focused ? "#0098DB" : "#acacac")};
  transition: color 0.3s ease-in-out;
  font-size: 1.1rem;
  align-self: center;
  margin-right: 0.5rem;
  margin-left: 1rem;
  flex-shrink: 0;
`;

const DateInput = styled(DatePicker)`
  background: none;
  outline: none;
  border: none;
  line-height: 1;
  font-weight: 600;
  font-size: 1.1rem;
  color: #333;
  flex: 1;
  padding-right: 50px;

  &::placeholder {
    color: #aaa;
    font-weight: 500;
  }
`;

const CustomDatePicker = ({
  selected,
  onChange,
  onFocus,
  onBlur,
  placeholderText,
}) => {
  const [isFocused, setFocused] = useState(false);
  const today = new Date();

  const datePickerRef = useRef();

  const handleFocus = () => {
    setFocused(true);
    if (onFocus) onFocus();
  };

  const handleBlur = () => {
    setFocused(false);
    if (onBlur) onBlur();
  };

  const handleSelect = (date) => {
    onChange(date);
    if (date) handleBlur();
  };

  const handleClear = () => {
    onChange(null);
  };

  return (
    <DatePickerWrapper>
      <InputContainer focused={isFocused}>
        <InputIcon focused={isFocused} icon={faCalendarDays} />
        <DateInput
          ref={datePickerRef}
          selected={selected}
          onChange={handleSelect}
          onFocus={handleFocus}
          onBlur={handleBlur}
          placeholderText={placeholderText}
          dateFormat="dd/MM/yyyy"
          isClearable={false}
          showYearDropdown
          scrollableYearDropdown
          yearDropdownItemNumber={100}
          maxDate={today}
        />
        {selected && <ClearIcon onClick={handleClear} />}
      </InputContainer>
    </DatePickerWrapper>
  );
};

export default CustomDatePicker;
